// Pending state for the artwork PDP's add to cart button.
//
// Horizon has no loading affordance for add to cart. `animateAddToCart()` in
// product-form.js looks like one but is an OPTIMISTIC success animation: it
// stamps data-added on the button the instant it is clicked and shows a
// checkmark for 800ms, whether or not the request has finished. The stock
// button also never renders until the request resolves, so between click and
// the cart drawer opening there is nothing on screen at all - which reads as
// the button not having worked.
//
// Start and end both come from ONE event. product-form.js dispatches
// CartLinesUpdateEvent immediately on submit, before it fetches, carrying a
// deferred `promise` that settles when the cart really has updated - the same
// promise cart-icon.js and header-actions.js wait on to update the count. So
// the event is the start signal and its promise is the end signal. Listening
// for `submit` instead would work, but would duplicate the theme's knowledge of
// which submits are add-to-cart.
//
// `shopify:cart:error` is a belt-and-braces stop: the promise rejects on a
// failed add, so `.then(done, done)` already covers it, but a dispatch path
// that errored without a promise would otherwise leave the button spinning.
(function () {
  var PENDING = 'data-pending';
  var SAFETY_MS = 15000;
  var timer = null;

  function buttons(scope) {
    var root = scope && scope.closest ? scope.closest('.fairplay-artwork') : null;
    return Array.prototype.slice.call((root || document).querySelectorAll('.fairplay-artwork__add'));
  }

  function stop() {
    clearTimeout(timer);
    timer = null;
    buttons().forEach(function (button) {
      button.removeAttribute(PENDING);
      button.removeAttribute('aria-busy');
    });
  }

  function start(scope) {
    var found = buttons(scope);
    if (!found.length) return;

    found.forEach(function (button) {
      button.setAttribute(PENDING, 'true');
      // The button keeps its accessible name; aria-busy is what tells a screen
      // reader the action is still in flight.
      button.setAttribute('aria-busy', 'true');
    });

    // Nothing should be able to leave this spinning forever - a dropped
    // connection would otherwise strand the button mid-action.
    clearTimeout(timer);
    timer = setTimeout(stop, SAFETY_MS);
  }

  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event.action !== 'add') return;

    var target = event.target instanceof Element ? event.target : null;
    if (target && !target.closest('.fairplay-artwork')) return;

    start(target);

    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(stop, stop);
    } else {
      stop();
    }
  });

  document.addEventListener('shopify:cart:error', function () {
    stop();
  });

  // A bfcache restore can bring the page back mid-action.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) stop();
  });
})();
